<template>
    <el-main class="site-content">
        <div class="container">
            <h1>UI</h1>

            <section>
                <h2>Иконки</h2>

                <p>
                    <icon-base width="20" height="20" viewBox="0 0 20 20" iconColor="#000"><icon-accept /></icon-base>
                    &mdash; accept
                </p>
                <p>
                    <icon-base width="12" height="12" viewBox="0 0 12 12" iconColor="#000"><icon-action /></icon-base>
                    &mdash; action
                </p>
                <p>
                    <icon-base width="14" height="8" viewBox="0 0 14 8" iconColor="#000"><icon-arrow-down /></icon-base>
                    &mdash; arrow down
                </p>
                <p>
                    <icon-base width="12" height="12" viewBox="0 0 12 12" iconColor="#000"><icon-arrow-left-second /></icon-base>
                    &mdash; arrow left second
                </p>
                <p>
                    <icon-base width="8" height="14" viewBox="0 0 8 14" iconColor="#000"><icon-arrow-right /></icon-base>
                    &mdash; arrow right
                </p>
                <p>
                    <icon-base width="12" height="12" viewBox="0 0 16 16" iconColor="#000"><icon-arrow-right-second /></icon-base>
                    &mdash; arrow right second
                </p>
                <p>
                    <icon-base width="14" height="8" viewBox="0 0 14 8" iconColor="#000"><icon-arrow-top /></icon-base>
                    &mdash; arrow top
                </p>
                <p>
                    <icon-base width="12" height="14" viewBox="0 0 12 14" iconColor="#000"><icon-book /></icon-base>
                    &mdash; book
                </p>
                <p>
                    <icon-base width="14" height="14" viewBox="0 0 14 14" iconColor="#000"><icon-cancel /></icon-base>
                    &mdash; cancel
                </p>
                <p>
                    <icon-base width="20" height="12" viewBox="0 0 20 12" iconColor="#000"><icon-career /></icon-base>
                    &mdash; career
                </p>
                <p>
                    <icon-base viewBox="0 0 21 20" width="21" height="20" iconColor="#000"><icon-cloud /></icon-base>
                    &mdash; cloud
                </p>
                <p>
                    <icon-base width="16" height="18" viewBox="0 0 16 18" iconColor="#000"><icon-delete /></icon-base>
                    &mdash; delete
                </p>
                <p>
                    <icon-base width="16" height="20" viewBox="0 0 16 20" iconColor="#000"><icon-doc /></icon-base>
                    &mdash; doc
                </p>
                <p>
                    <icon-base width="20" height="20" viewBox="0 0 20 20" iconColor="#000"><icon-donut /></icon-base>
                    &mdash; donut
                </p>
                <p>
                    <icon-base width="12" height="10" viewBox="0 0 12 10" iconColor="#000"><icon-double-arrow-right /></icon-base>
                    &mdash; double arrow right
                </p>
                <p>
                    <icon-base width="10" height="14" viewBox="0 0 10 14" iconColor="#000"><icon-draggable /></icon-base>
                    &mdash; draggable
                </p>
                <p>
                    <icon-base width="18" height="18" viewBox="0 0 18 18" iconColor="#000"><icon-edit /></icon-base>
                    &mdash; edit
                </p>
                <p>
                    <icon-base width="20" height="20" viewBox="0 0 20 20" iconColor="#000"><icon-faq /></icon-base>
                    &mdash; faq
                </p>
                <p>
                    <icon-base width="18" height="18" viewBox="0 0 18 18" iconColor="#000"><icon-filter /></icon-base>
                    &mdash; filter
                </p>
                <p>
                    <icon-base width="20" height="20" viewBox="0 0 20 20" iconColor="#000"><icon-info /></icon-base>
                    &mdash; info
                </p>
                <p>
                    <icon-base width="20" height="20" viewBox="0 0 20 20" iconColor="#000"><icon-profile /></icon-base>
                    &mdash; profile
                </p>
                <p>
                    <icon-base width="22" height="20" viewBox="0 0 22 20" iconColor="#000"><icon-program /></icon-base>
                    &mdash; program
                </p>
                    <icon-base width="20" height="20" viewBox="0 0 300 300" iconColor="#000"><icon-remove /></icon-base>
                    &mdash; remove
                </p>
                <p>
                    <icon-base width="16" height="16" viewBox="0 0 512 512" iconColor="#000"><icon-save /></icon-base>
                    &mdash; save
                </p>
                <p>
                    <icon-base width="20" height="20" viewBox="0 0 24 24" iconColor="#000"><icon-search /></icon-base>
                    &mdash; search
                </p>
                <p>
                    <icon-base width="4" height="12" viewBox="0 0 4 12" iconColor="#000"><icon-settings /></icon-base>
                    &mdash; settings
                </p>
                <p>
                    <icon-base width="14" height="14" viewBox="0 0 14 14" iconColor="#000"><icon-settings-main /></icon-base>
                    &mdash; settings main
                </p>
                <p>
                    <icon-base width="12" height="10" viewBox="0 0 12 10" iconColor="#000"><icon-success /></icon-base>
                    &mdash; success
                </p>
                <p>
                    <icon-base width="24" height="24" viewBox="0 0 24 24" iconColor="#000"><icon-video /></icon-base>
                    &mdash; video
                </p>
            </section>

            <section>
                <h2>Кнопки</h2>

                <button type="button" class="btn">Назад</button>
                <button type="button" class="btn btn_primary">Редактировать</button>
                <button type="button" class="btn btn_success">Утвердить</button>
                <button type="button" class="btn btn_danger">Отклонить</button>
                <button type="button" class="btn btn_action">Создать пользователя</button>
                <button type="button" class="btn btn_action-second">
                    Добавить трудовые действия

                    <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                </button>

                <br>
                <br>

                <button type="button" class="btn btn_success btn_small">
                    Сохранить

                    <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon"><icon-save /></icon-base>
                </button>

                <button type="button" class="btn btn_success btn_small">
                    Применить

                    <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                </button>

                <button type="button" class="btn btn_danger btn_small">
                    Отменить

                    <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon"><icon-cancel /></icon-base>
                </button>

                <button type="button" class="btn btn_danger-second btn_small">
                    Удалить выбранные

                    <icon-base width="16" height="18" viewBox="0 0 16 18" class="btn__icon"><icon-delete /></icon-base>
                </button>

                <button type="button" class="btn btn_primary-second btn_small">
                    Отметить как прочитанные

                    <icon-base width="12" height="10" viewBox="0 0 12 10" class="btn__icon"><icon-success /></icon-base>
                </button>

                <button type="button" class="btn btn_success btn_small" disabled>
                    Применить

                    <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon"><icon-action /></icon-base>
                </button>

                <br>
                <br>

                <button class="settings-btn">
                    <icon-base viewBox="0 0 4 12" class="settings-btn__icon"><icon-settings /></icon-base>
                </button>

                <button class="settings-btn-main ml-12">
                    <icon-base viewBox="0 0 14 14" class="settings-btn__icon"><icon-settings-main /></icon-base>
                </button>

                <button type="button" class="edit-btn ml-12">
                    <icon-base viewBox="0 0 18 18" iconColor="#d2d7e3" class="edit-btn__icon">
                        <icon-edit />
                    </icon-base>
                </button>

                <br>
                <br>

                <selector-btn :options="accordionOptions" portal="selectorModal" @clickOnItem="callback"></selector-btn>

                <br>

                <selector-btn :options="accordionOptions" portal="selectorModal" :inAccordion="true" @clickOnItem="callback"></selector-btn>
            </section>

            <section>
                <h2>Форма</h2>

                <form action="#" class="search-form">
                    <div class="search-form__inner">
                         <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': search && search.length !== 0 }" placeholder="Поиск" v-model.trim="search">

                        <button v-if="search && search.length !== 0" class="search-form__reset" @click="search = ''">
                            <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                        </button>

                        <button type="submit" class="search-form__submit" disabled>
                            <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                        </button>
                    </div>
                </form>

                <br>

                <input type="search" name="search" class="input" placeholder="Поиск" disabled>

                <br>
                <br>

                <input type="text" name="name" class="input" placeholder="ФИО">

                <br>
                <br>

                <validate-input v-model="email" placeholder="Почта" type="text" v-bind:error="emailError" v-on:update:error="emailError = $event" :validateOptions="['empty', 'email']" />

                <br>

                <masked-input mask="\+\7 (111) 111-11-11" name="phone" class="input" placeholder="Телефон" />

                <br>
                <br>

                <textarea class="textarea" placeholder="Введите комментарий" v-autogrow></textarea>

                <br>
                <br>

                <v-select class="select" placeholder="Выберите причину" :clearable="false" :options="['Специалист', 'Магистр', 'Кандидат наук']">
                    <template #no-options="{ search, searching, loading }">
                        {{ SELECT_NOT_FOUND }}
                    </template>
                    <template #open-indicator="{ attributes }">
                        <span v-bind="attributes">
                            <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                        </span>
                    </template>
                </v-select>

                <br>

                <div @keyup.enter="searchForSelect">
                    <v-select class="select" name="name" label="name" placeholder="Наименование квалификации" :clearable="false" v-model="select"  :options="optionsForSelectors">
                        <template #no-options="{ search, searching, loading }">
                            <local-preloader v-if="selectPreloader" />
                            <span v-else>Введите в поисковую строку и нажмите Enter, чтобы загрузить квалификации</span>
                        </template>
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes">
                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                            </span>
                        </template>
                    </v-select>
                </div>
            </section>

            <section>
                <el-checkbox v-model="checkbox">Об&nbsp;изменениях ОРК</el-checkbox>
            </section>

            <section>
                <h2>Аккордеон</h2>

                <button type="button" class="collapse-btn mb-16" @click="closeAccordions">
                    <icon-base viewBox="0 0 14 8" class="collapse-btn__icon"><icon-arrow-top /></icon-base>
                </button>

                <accordion>
                    <accordion-item parent highlighted :bus="bus">
                        <template #accordion-head>
                            <div tabindex="0" class="accordion__head">
                                <div class="accordion__head-item">
                                    <p class="accordion__title">Сквозные виды профессиональной деятельности в&nbsp;промышленности</p>
                                </div>

                                <div class="accordion__head-item">
                                    <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                        <icon-arrow-down />
                                    </icon-base>
                                </div>
                            </div>
                        </template>

                        <div class="accordion__content">
                            <accordion>
                                <accordion-item :bus="bus">
                                    <template #accordion-head>
                                        <div tabindex="0" class="accordion__head">
                                            <div class="accordion__head-item">
                                                <p class="accordion__title">Сквозные виды профессиональной деятельности в&nbsp;промышленности</p>
                                            </div>

                                            <div class="accordion__head-item">
                                                <button type="button" class="action-btn accordion__action" @click.stop>
                                                    <span class="action-btn__text">Создать или найти ВПД</span>

                                                    <span class="action-btn__helper">
                                                        <icon-base viewBox="0 0 12 12" class="action-btn__icon"><icon-action /></icon-base>
                                                    </span>
                                                </button>

                                                <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                                    <icon-arrow-down />
                                                </icon-base>
                                            </div>
                                        </div>
                                    </template>
                                    
                                    <div class="accordion__content">
                                        Сквозные виды профессиональной деятельности в&nbsp;промышленности    
                                    </div>
                                </accordion-item>
                                <accordion-item :bus="bus">
                                    <template #accordion-head>
                                        <div tabindex="0" class="accordion__head">
                                            <div class="accordion__head-item">
                                                <p class="accordion__title">Автомобилестроение</p>
                                            </div>

                                            <div class="accordion__head-item">
                                                <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                                    <icon-arrow-down />
                                                </icon-base>
                                            </div>
                                        </div>
                                    </template>

                                    <div class="accordion__content">
                                        Автомобилестроение
                                    </div>
                                </accordion-item>
                            </accordion>
                        </div>
                    </accordion-item>
                    <accordion-item parent :bus="bus">
                        <template #accordion-head>
                            <div tabindex="0" class="accordion__head">
                                <div class="accordion__head-item">
                                    <p class="accordion__title">Сквозные виды профессиональной деятельности в&nbsp;промышленности</p>
                                </div>

                                <div class="accordion__head-item">
                                    <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                        <icon-arrow-down />
                                    </icon-base>
                                </div>
                            </div>
                        </template>

                        <div class="accordion__content">
                            <span class="status">Утверждено</span>
                        </div>
                    </accordion-item>
                </accordion>
            </section>

            <section>
                <accordion class="accordion accordion_second">
                    <accordion-item :bus="bus">
                        <template #accordion-head>
                            <div class="accordion__trigger">
                                <div class="accordion-data-list">
                                    <div class="accordion-data-list__item">
                                        <div class="accordion-data-list__column text-center">
                                            A
                                        </div>
                                        <div class="accordion-data-list__column">
                                            Педагогическая деятельность по&nbsp;проектированию и&nbsp;реализации образовательного процесса в&nbsp;образовательных организациях дошкольного, начального общего, основного общего, среднего общего образования 
                                        </div>
                                        <div class="accordion-data-list__column text-center">
                                            6
                                        </div>
                                    </div>
                                </div>

                                <button type="button" class="accordion__toggler">
                                    <icon-base viewBox="0 0 14 8"><icon-arrow-down /></icon-base>
                                </button>
                            </div>
                        </template>

                        <div class="accordion__data">
                            <div class="accordion-data-list">
                                <div class="accordion-data-list__item">
                                    <div class="accordion-data-list__column text-center">
                                        A/01.6
                                    </div>
                                    <div class="accordion-data-list__column">
                                        Общепедагогическая функция. Обучение    
                                    </div>
                                    <div class="accordion-data-list__column text-center">
                                        6
                                    </div>
                                </div>
                                <div class="accordion-data-list__item">
                                    <div class="accordion-data-list__column text-center">
                                        A/02.6
                                    </div>
                                    <div class="accordion-data-list__column">
                                        Воспитательная деятельность
                                    </div>
                                    <div class="accordion-data-list__column text-center">
                                        6
                                    </div>
                                </div>
                                <div class="accordion-data-list__item">
                                    <div class="accordion-data-list__column text-center">
                                        A/03.6
                                    </div>
                                    <div class="accordion-data-list__column">
                                        Развивающая деятельность
                                    </div>
                                    <div class="accordion-data-list__column text-center">
                                        6
                                    </div>
                                </div>
                                <div class="accordion-data-list__item accordion-data-list__item_full">
                                    <accordion class="accordion">
                                        <accordion-item :bus="bus">
                                            <template #accordion-head>
                                                <button type="button" class="accordion__top">
                                                    Развивающая деятельность

                                                    <icon-base viewBox="0 0 14 8" class="accordion__arrow"><icon-arrow-down /></icon-base>
                                                </button>
                                            </template>

                                            <div class="accordion__contents">
                                                <div class="accordion-data-list accordion-data-list_second">
                                                    <div class="accordion-data-list__item">
                                                        <div class="accordion-data-list__column text-center">
                                                            A/01.6
                                                        </div>
                                                        <div class="accordion-data-list__column">
                                                            Общепедагогическая функция. Обучение    
                                                        </div>
                                                        <div class="accordion-data-list__column text-center">
                                                            6
                                                        </div>
                                                    </div>
                                                    <div class="accordion-data-list__item">
                                                        <div class="accordion-data-list__column text-center">
                                                            A/02.6
                                                        </div>
                                                        <div class="accordion-data-list__column">
                                                            Воспитательная деятельность
                                                        </div>
                                                        <div class="accordion-data-list__column text-center">
                                                            6
                                                        </div>
                                                    </div>
                                                    <div class="accordion-data-list__item">
                                                        <div class="accordion-data-list__column text-center">
                                                            A/03.6
                                                        </div>
                                                        <div class="accordion-data-list__column">
                                                            Развивающая деятельность
                                                        </div>
                                                        <div class="accordion-data-list__column text-center">
                                                            6
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </accordion-item>
                                    </accordion>
                                </div>
                            </div>
                        </div>
                    </accordion-item>
                    <accordion-item :bus="bus">
                        <template #accordion-head>
                            <div class="accordion__trigger">
                                <div class="accordion-data-list">
                                    <div class="accordion-data-list__item">
                                        <div class="accordion-data-list__column text-center">
                                            В
                                        </div>
                                        <div class="accordion-data-list__column">
                                            Педагогическая деятельность по&nbsp;проектированию и&nbsp;реализации основных общеобразовательных программ
                                        </div>
                                        <div class="accordion-data-list__column text-center">
                                            6
                                        </div>
                                    </div>
                                </div>

                                <button type="button" class="accordion__toggler">
                                    <icon-base viewBox="0 0 14 8"><icon-arrow-down /></icon-base>
                                </button>
                            </div>
                        </template>

                        <div class="accordion__data">
                            <div class="accordion-data-list">
                                <div class="accordion-data-list__item">
                                    <div class="accordion-data-list__column text-center">
                                        В/01.6
                                    </div>
                                    <div class="accordion-data-list__column">
                                        Общепедагогическая функция. Обучение    
                                    </div>
                                    <div class="accordion-data-list__column text-center">
                                        6
                                    </div>
                                </div>
                                <div class="accordion-data-list__item">
                                    <div class="accordion-data-list__column text-center">
                                        В/02.6
                                    </div>
                                    <div class="accordion-data-list__column">
                                        Воспитательная деятельность
                                    </div>
                                    <div class="accordion-data-list__column text-center">
                                        6
                                    </div>
                                </div>
                                <div class="accordion-data-list__item">
                                    <div class="accordion-data-list__column text-center">
                                        В/03.6
                                    </div>
                                    <div class="accordion-data-list__column">
                                        Развивающая деятельность
                                    </div>
                                    <div class="accordion-data-list__column text-center">
                                        6
                                    </div>
                                </div>
                            </div>
                        </div>
                    </accordion-item>
                </accordion>
            </section>

            <section>
                <h2>Статус</h2>

                <span class="status">Утверждено</span>

                <br>
                <br>

                <span class="status status_waiting">На&nbsp;утверждении</span>

                <br>
                <br>

                <span class="status status_declined">Отклонен</span>
            </section>

            <section>
                <h2>Таблицы</h2>

                <div class="section">
                    <h3>Сортировка</h3>

                    <el-table
                        class="table"
                        cell-class-name="table__cell"
                        header-cell-class-name="table__title"
                        ref="tableSort"
                        :data="tableData"
                        :default-sort="{ prop: 'id', order: 'descending' }"
                    >
                        <el-table-column
                            label="Название ОРК"
                            prop="name"
                            sortable
                            :min-width="400"
                        >
                            <template slot-scope="scope">
                                <span v-html="scope.row.name"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Разработчик"
                            prop="role"
                            sortable
                            :min-width="400"
                        >
                            <template slot-scope="scope">
                                <span v-html="scope.row.role"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Статус"
                            prop="status"
                            sort-by="status.id"
                            sortable
                            :width="200"
                        >
                            <template slot-scope="scope">
                                <span :class="{ 'status': true, 'status_success': scope.row.status.id === 1, 'status_waiting': scope.row.status.id === 2, 'status_declined': scope.row.status.id === 3 }" v-html="scope.row.status.label.text"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="ПС"
                            prop="ps"
                            sortable
                            :width="80"
                        ></el-table-column>
                        <el-table-column
                            label="ПК"
                            prop="pk"
                            sortable
                            :width="80"
                        ></el-table-column>
                    </el-table>
                </div>

                <div class="section">
                    <h3>Фильтры и&nbsp;чекбоксы</h3>

                    <div class="filter">
                        <el-row :gutter="12" type="flex" class="filter__inner">
                            <el-col :span="5">
                                <v-select class="select" placeholder="Статус" :clearable="false" :options="filterStatusOptions" v-model="filters.status">
                                    <template #no-options="{ search, searching, loading }">
                                        {{ SELECT_NOT_FOUND }}
                                    </template>
                                    <template #open-indicator="{ attributes }">
                                        <span v-bind="attributes">
                                            <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                        </span>
                                    </template>
                                </v-select>
                            </el-col>
                            <el-col :span="5">
                                <v-select class="select" placeholder="ПК" :clearable="false" :options="filterPkOptions" v-model="filters.pk">
                                    <template #no-options="{ search, searching, loading }">
                                        {{ SELECT_NOT_FOUND }}
                                    </template>
                                    <template #open-indicator="{ attributes }">
                                        <span v-bind="attributes">
                                            <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                        </span>
                                    </template>
                                </v-select>
                            </el-col>
                            <el-col :span="5">
                                <button type="button" class="filter__reset" @click="clearFilter">Сбросить фильтры</button>
                            </el-col>
                        </el-row>
                    </div>

                    <el-table
                        class="table mt-24"
                        cell-class-name="table__cell"
                        header-cell-class-name="table__title"
                        ref="tableFilter"
                        :default-sort="{ prop: 'id', order: 'descending' }"
                        :data="filteredData"
                    >
                        <el-table-column
                            align="center"
                            type="selection"
                            width="24"
                        >
                        </el-table-column>
                        <el-table-column
                            label="Название ОРК"
                            prop="name"
                            sortable
                            :min-width="400"
                        >
                            <template slot-scope="scope">
                                <span v-html="scope.row.name"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Разработчик"
                            prop="role"
                            sortable
                            :min-width="400"
                        >
                            <template slot-scope="scope">
                                <span v-html="scope.row.role"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Статус"
                            prop="status"
                            sort-by="status.id"
                            sortable
                            :width="200"
                        >
                            <template slot-scope="scope">
                                <span :class="{ 'status': true, 'status_success': scope.row.status.id === 1, 'status_waiting': scope.row.status.id === 2, 'status_declined': scope.row.status.id === 3 }" v-html="scope.row.status.label.text"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="ПС"
                            prop="ps"
                            sortable
                            :width="80"
                        ></el-table-column>
                        <el-table-column
                            label="ПК"
                            prop="pk"
                            sortable
                            :width="80"
                        ></el-table-column>
                    </el-table>
                </div>

                <div class="section">
                    <h3>Кастомные кнопки</h3>

                    <div>
                        <el-table
                            class="table"
                            cell-class-name="table__cell"
                            header-cell-class-name="table__title"
                            ref="tableFilter"
                            :default-sort="{ prop: 'id', order: 'descending' }"
                            :data="filteredData"
                        >
                            <el-table-column
                                type="selection"
                                width="24"
                                fixed
                            >
                            </el-table-column>

                            <el-table-column
                                fixed
                                width="48"
                            >
                                <template slot="header" slot-scope="scope">
                                    <button class="settings-btn-main">
                                        <icon-base viewBox="0 0 14 14" class="settings-btn__icon"><icon-settings-main /></icon-base>
                                    </button>
                                </template>

                                <template slot-scope="scope">
                                    <button class="settings-btn">
                                        <icon-base viewBox="0 0 4 12" class="settings-btn__icon"><icon-settings /></icon-base>
                                    </button>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Название ОРК"
                                prop="name"
                                sortable
                                :min-width="400"
                            >
                                <template slot-scope="scope">
                                    <span v-html="scope.row.name"></span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Разработчик"
                                prop="role"
                                sortable
                                :min-width="400"
                            >
                                <template slot-scope="scope">
                                    <span v-html="scope.row.role"></span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="Статус"
                                prop="status"
                                sort-by="status.id"
                                sortable
                                :width="200"
                            >
                                <template slot-scope="scope">
                                    <span :class="{ 'status': true, 'status_success': scope.row.status.id === 1, 'status_waiting': scope.row.status.id === 2, 'status_declined': scope.row.status.id === 3 }" v-html="scope.row.status.label.text"></span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="ПС"
                                prop="ps"
                                sortable
                                :width="80"
                            ></el-table-column>
                            <el-table-column
                                label="ПК"
                                prop="pk"
                                sortable
                                :width="80"
                            ></el-table-column>
                        </el-table>
                    </div>
                </div>

                <div class="section">
                    <h3>Уведомления</h3>

                    <el-table
                        class="table"
                        cell-class-name="table__cell"
                        header-cell-class-name="table__title"
                        ref="tableFilter"
                        :default-sort="{ prop: 'id', order: 'descending' }"
                        :data="noticesData"
                    >
                        <el-table-column
                            type="selection"
                            width="24"
                        >
                        </el-table-column>

                        <el-table-column
                            prop="data"
                            :min-width="500"
                        >
                            <template slot="header" slot-scope="scope">
                                <button type="button" class="btn btn_danger-second btn_small">
                                    Удалить выбранные

                                    <icon-base width="16" height="18" viewBox="0 0 16 18" iconColor="#e54d60" class="btn__icon"><icon-delete /></icon-base>
                                </button>

                                <button type="button" class="btn btn_primary-second btn_small">
                                    Отметить как прочитанные

                                    <icon-base width="12" height="10" viewBox="0 0 12 10" iconColor="#4981f1" class="btn__icon"><icon-success /></icon-base>
                                </button>
                            </template>

                            <template slot-scope="scope">
                                <p class="table-title mb-4">
                                    <span v-html="scope.row.data.title"></span>
                                    <span class="table-title__new"></span>
                                </p>
                                <p class="table__text" v-html="scope.row.data.text"></p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            align="left"
                            label="Дата"
                            prop="date"
                            sortable
                            :min-width="100"
                            :formatter="dateFormatter"
                        >
                        </el-table-column>

                        <el-table-column
                            :width="40"
                        >
                            <template slot-scope="scope">
                                <button class="expand-btn">
                                    <icon-base viewBox="0 0 14 8" class="expand-btn__icon"><icon-arrow-down /></icon-base>
                                </button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="section">
                    <div class="programs-list">
                        <div class="programs-list__inner">
                            <div class="programs-list__item">
                                <div class="programs-list__content">
                                    <div class="programs-list__content-item">
                                        Стажировка по&nbsp;профессии &laquo;Цифровой куратор&raquo;
                                    </div>

                                    <div class="programs-list__content-item">
                                        <div class="programs-list__extra">
                                            <button class="settings-btn">
                                                <icon-base viewBox="0 0 4 12" class="settings-btn__icon"><icon-settings /></icon-base>
                                            </button>
                                        </div>
                                    
                                        <div class="programs-list__extra">
                                            <icon-base viewBox="0 0 21 20" class="programs-list__cloud">
                                                <icon-cloud />
                                            </icon-base>
                                        </div>
                                    </div>
                                </div>

                                <footer class="programs-list__footer">
                                    Повышение квалификации

                                    <icon-base viewBox="0 0 8 14" class="programs-list__more">
                                        <icon-arrow-right />
                                    </icon-base>
                                </footer>
                            </div>
                            <div class="programs-list__item">
                                <div class="programs-list__content">
                                    <div class="programs-list__content-item">
                                        Методика организации и&nbsp;проведения профессионально-общественной аккредитации образовательных программ
                                    </div>
                                </div>

                                <footer class="programs-list__footer">
                                    Повышение квалификации

                                    <icon-base viewBox="0 0 8 14" class="programs-list__more">
                                        <icon-arrow-right />
                                    </icon-base>
                                </footer>
                            </div>
                            <div class="programs-list__item">
                                <div class="programs-list__content">
                                    Методика организации и&nbsp;проведения профессионально-общественной аккредитации образовательных программ
                                </div>

                                <footer class="programs-list__footer">
                                    Повышение квалификации

                                    <icon-base viewBox="0 0 8 14" class="programs-list__more">
                                        <icon-arrow-right />
                                    </icon-base>
                                </footer>
                            </div>
                            <div class="programs-list__item">
                                <div class="programs-list__content">
                                    <div class="programs-list__content-item">
                                        Стажировка по&nbsp;профессии &laquo;Цифровой куратор&raquo;
                                    </div>

                                    <div class="programs-list__content-item">
                                        <div class="programs-list__extra">
                                            <icon-base width="21" height="20" viewBox="0 0 21 20" class="programs-list__cloud">
                                                <icon-cloud />
                                            </icon-base>
                                        </div>
                                    </div>
                                </div>

                                <footer class="programs-list__footer">
                                    Повышение квалификации

<!--                                    <icon-base viewBox="0 0 8 14" class="programs-list__more">-->
<!--                                        <icon-arrow-right />-->
<!--                                    </icon-base>-->
                                </footer>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div class="entry">
                    <div class="entry__inner">
                        <div class="entry__item">
                            Техник&nbsp;&mdash; лаборант по&nbsp;химическому анализу воды в&nbsp;системах теплоснабжения, водоснабджения и&nbsp;водоотведения (4&nbsp;уровень квалификации)
                        </div>
                        <div class="entry__item">
                            <div class="entry__actions">
                                <div class="entry__actions-item">
                                    <span class="entry__status"></span>
                                </div>
                                
                                <div class="entry__actions-item">
                                    <button class="settings-btn">
                                        <icon-base viewBox="0 0 4 12" class="settings-btn__icon"><icon-settings /></icon-base>
                                    </button>
                                </div>

                                <div class="entry__actions-item">
                                    <button type="button" class="draggable-btn">
                                        <icon-base viewBox="0 0 10 14"><icon-draggable /></icon-base>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section">
                <h2>Табы</h2>

                <tabs>
                    <tab title="Трудовые действия">
                        Трудовые действия
                    </tab>
                    <tab title="Знания">
                        Знания
                    </tab>
                    <tab title="Умения">
                        Умения
                    </tab>
                </tabs>

                <tabs caption="Взаимосвязи">
                    <tab title="Список">
                    </tab>
                    <tab title="Диаграмма">
                    </tab>
                </tabs>

                <tabs class="tabs_second">
                    <tab title="<button type='button' class='tabs__btn'>1</button>">
                        <h2>Дескрипторы компетенции</h2>
                    </tab>
                    <tab title="<button type='button' class='tabs__btn'>2</button>">
                        <h2>Выбрать область профессиональной</h2>
                    </tab>
                    <tab title="<button type='button' class='tabs__btn'>3</button>">
                        <h2>ОПД</h2>
                    </tab>
                    <tab title="<button type='button' class='tabs__btn'>4</button>">
                        <h2>ПК</h2>
                    </tab>
                    <tab title="<button type='button' class='tabs__btn'>5</button>">
                        <h2>ВПС</h2>
                    </tab>
                    <tab title="<button type='button' class='tabs__btn'>6</button>">
                        <h2>Общие компетецнии</h2>
                    </tab>
                    <tab title="<button type='button' class='tabs__btn'>7</button>">
                        <h2>Взаимосвязи ПК</h2>
                    </tab>
                    <tab title="<button type='button' class='tabs__btn'>8</button>">
                        <h2>ОРК</h2>
                    </tab>
                    <tab title="<button type='button' class='tabs__btn'>9</button>">
                        <h2>ВПД</h2>
                    </tab>
                </tabs>
            </section>
        </div>
    </el-main>
</template>

<style scoped lang="scss">
    section {
        &:not(:first-of-type) {
            margin-top: 3.6rem;
        }
    }
</style>

<script>
import Vue from 'vue';

import MaskedInput from 'vue-masked-input';
import ValidateInput from '@/components/ValidateInput'
import WizardStepsList from '@/components/WizardStepsList';
import LocalPreloader from '@/components/LocalPreloader'
import SelectorBtn from '@/components/SelectorBtn';

import { isPrimitive } from '@/helpers.js';
import constants from '@/constants.js';

import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import Tab from '@/components/Tabs/Tab';
import Tabs from '@/components/Tabs/Tabs';

export default {
    name: 'UI',
    components: {
        Accordion,
        AccordionItem,
        MaskedInput,
        Tab,
        Tabs,
        WizardStepsList,
        ValidateInput,
        LocalPreloader,
        SelectorBtn
    },
    methods: {
        callback(emitObj) {
            this[emitObj.callback](emitObj.args)
        },
        optionsClick() {
            console.log('optionsClick');
        },

        searchForSelect(val) {
            console.log('val: ', val.target.value);
            this.selectPreloader = true
            setTimeout(() => {
                this.optionsForSelectors = [
                    {
                        name: '1 опция'
                    },
                    {
                        name: '2 опция'
                    },
                    {
                        name: '3 опция'
                    },
                    {
                        name: '4 опция'
                    },
                ]
                this.selectPreloader = false
            }, 5000);
        },

        clearFilter() {
            this.filters = {};
        },
        dateFormatter(row, column, cellValue, index) {
            return new Date(row.date).toLocaleDateString('ru-RU', { year: 'numeric', month: '2-digit', day: '2-digit' });
        },
        closeAccordions: function() {
            this.bus.$emit('closeAccordion');
        },
        isPrimitive: isPrimitive,
    },
    data() {
        return {
            bus: new Vue(),
            checkbox: true,
            // Кнопка с селектором
            accordionOptions: [
                {
                    name: 'Редактировать',
                    callback: 'optionsClick'
                },
                {
                    name: 'Удалить',
                    warning: true,
                    callback: 'optionsClick'
                }
            ],
            // Поисковая форма
            search: '',
            // Валидированный инпут
            email: '',
            emailError: false,
            // Селектор с поиском
            select: '',
            optionsForSelectors: [],
            selectPreloader: false,
            // Демо кодов
            codesData: [
                {
                    id: 1,
                    code: '012',
                    name: 'Сквозные виды профессиональной деятельности в промышленности',
                },
                {
                    id: 2,
                    code: '120',
                    name: 'Финансы и экономика',
                },
                {
                    id: 3,
                    code: '203',
                    name: 'Строительство и жилищно-коммунальное хозяйство',
                },
                {
                    id: 4,
                    code: '3493',
                    name: 'Сервис, оказание услуг населению',
                },
                {
                    id: 5,
                    code: '3874',
                    name: 'Сквозные виды профессиональной деятельности в промышленности',
                },
                {
                    id: 6,
                    code: '8274',
                    name: 'Финансы и экономика',
                },
                {
                    id: 7,
                    code: '374',
                    name: 'Строительство и жилищно-коммунальное хозяйство',
                },
                {
                    id: 8,
                    code: '3873',
                    name: 'Сервис, оказание услуг населению',
                },
            ],
            // Текущий фильтр для таблицы
            filters: {
                // status: {
                //     id: 1,
                //     label: constants.STATUSES_DICT['1'],
                // },
                // ps: 23,
                // pk: 220,
            },
            // Фильтр "ПК"
            filterPkOptions: [
                214,
                220,
                999
            ],
            // Фильтр статусов
            filterStatusOptions: [
                {
                    id: 1,
                    label: constants.STATUSES_DICT['1'],
                },
                {
                    id: 2,
                    label: constants.STATUSES_DICT['2'],
                },
                {
                    id: 3,
                    label: constants.STATUSES_DICT['3'],
                },
            ],
            // Демо уведомлений
            noticesData: [
                {
                    id: 1,
                    data: {
                        title: 'Выполнение работ по&nbsp;неразрушающему контролю (НК) контролируемых объектов (материалов и&nbsp;сварных соединений)',
                        text: 'Адживика изоморфна времени. Гегельянство, конечно, транспонирует дуализм. Отношение к&nbsp;современности естественно осмысляет неоднозначный гедонизм...',
                    },
                    date: '2020.04.21',
                },
                {
                    id: 2,
                    data: {
                        title: 'Выполнение работ по&nbsp;неразрушающему контролю (НК) контролируемых объектов (материалов и&nbsp;сварных соединений)',
                        text: 'Адживика изоморфна времени. Гегельянство, конечно, транспонирует дуализм. Отношение к&nbsp;современности естественно осмысляет неоднозначный гедонизм...',
                    },
                    date: '2019.06.29',
                },
                {
                    id: 3,
                    data: {
                        title: 'Выполнение работ по&nbsp;неразрушающему контролю (НК) контролируемых объектов (материалов и&nbsp;сварных соединений)',
                        text: 'Адживика изоморфна времени. Гегельянство, конечно, транспонирует дуализм. Отношение к&nbsp;современности естественно осмысляет неоднозначный гедонизм...',
                    },
                    date: '2018.06.30',
                },
                {
                    id: 4,
                    data: {
                        title: 'Выполнение работ по&nbsp;неразрушающему контролю (НК) контролируемых объектов (материалов и&nbsp;сварных соединений)',
                        text: 'Адживика изоморфна времени. Гегельянство, конечно, транспонирует дуализм. Отношение к&nbsp;современности естественно осмысляет неоднозначный гедонизм...',
                    },
                    date: '2018.01.05',
                },
                {
                    id: 5,
                    data: {
                        title: 'Выполнение работ по&nbsp;неразрушающему контролю (НК) контролируемых объектов (материалов и&nbsp;сварных соединений)',
                        text: 'Адживика изоморфна времени. Гегельянство, конечно, транспонирует дуализм. Отношение к&nbsp;современности естественно осмысляет неоднозначный гедонизм...',
                    },
                    date: '1998.06.22',
                },
            ],
            // Демо таблица
            tableData: [
                {
                    id: 1,
                    name: 'Взаимосвязи промышленности и&nbsp;автомобилестроения',
                    role: 'СПК на&nbsp;промышленности',
                    status: {
                        id: 1,
                        label: constants.STATUSES_DICT['1'],
                    },
                    ps: 23,
                    pk: 220,
                },
                {
                    id: 2,
                    name: 'Взаимосвязи педагогики и&nbsp;учебной практики',
                    role: 'СПК на&nbsp;промышленности',
                    status: {
                        id: 2,
                        label: constants.STATUSES_DICT['2'],
                    },
                    ps: 23,
                    pk: 214,
                },
                {
                    id: 3,
                    name: 'Рамка военной промышленности',
                    role: 'СПК на&nbsp;военной отрасли',
                    status: {
                        id: 1,
                        label: constants.STATUSES_DICT['1'],
                    },
                    ps: 10,
                    pk: 62,
                },
                {
                    id: 4,
                    name: 'Взаимосвязи индустрии красоты и&nbsp;пищевой промышленности',
                    role: 'СПК на&nbsp;производстве средств личного пользования',
                    status: {
                        id: 1,
                        label: constants.STATUSES_DICT['1'],
                    },
                    ps: 68,
                    pk: 45,
                },
                {
                    id: 5,
                    name: 'Взаимосвязи индустрии красоты и&nbsp;пищевой промышленности',
                    role: 'СПК на&nbsp;производстве средств личного пользования',
                    status: {
                        id: 1,
                        label: constants.STATUSES_DICT['1'],
                    },
                    ps: 68,
                    pk: 45,
                },
                {
                    id: 6,
                    name: 'Рамка военной промышленности',
                    role: 'СПК на&nbsp;военной отрасли',
                    status: {
                        id: 3,
                        label: constants.STATUSES_DICT['3'],
                    },
                    ps: 43,
                    pk: 71,
                },
            ],
            // Настройки vue-scroll
            // ops: {
            //     rail: {
            //         background: '#f0f5fe',
            //         borderRadius: '0.2rem',
            //         opacity: 1,
            //         size: '0.4rem',
            //     },
            //     bar: {
            //         background: '#d2d7e3',
            //         borderRadius: '0.2rem',
            //         keepShow: true,
            //         size: '0.4rem',
            //     },
            // },
        }
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
        this.STATUSES_DICT = constants.STATUSES_DICT;
    },
    computed: {
        filteredData() {
            return this.tableData.filter((item) => {
                // Нет ключей в фильтре - показываем все
                if (!Object.entries(this.filters).length) {
                    return true;
                }

                for (const [key, value] of Object.entries(item)) {
                    if (key in this.filters) {
                        // Если значение примитив, сравниваем значения, в ином случае проверяем id объекта
                        if (isPrimitive(value) && value !== this.filters[key]) {
                            return false;
                        } else if (this.filters[key]?.id !== value.id) {
                            return false;
                        }
                    }
                }

                return true;
            });
        }
    }
}
</script>
